<button
  mat-stroked-button
  [ixTest]="['service-status', service?.service]"
  [matTooltip]="'The {name} service is {status}' | translate: {
    name: service?.service | mapValue: serviceNames,
    status: service?.state | lowercase
  }"
  [matTooltipDisabled]="!service"
  [ngClass]="statusClass"
>
  {{ service?.state || serviceStatus.Loading }}
</button>
